import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ResellerService } from "../reseller.service";
import { ToastrService } from "../../shared/toastr.service";
import { Subject } from "rxjs";
import { catchError, takeUntil } from "rxjs/operators";
import { of } from "rxjs";
import { AttachDomainDialogData } from "../reseller.interface";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../shared/error-state-matcher";

@Component({
  selector: "app-attach-domain-dialog",
  templateUrl: "./attach-domain-dialog.component.html",
  styleUrls: ["./attach-domain-dialog.component.scss"],
  standalone: false,
})
export class AttachDomainDialogComponent implements OnInit, OnDestroy {
  form: FormGroup;
  loading = false;
  availableDomains: string[] = [];
  readonly identityLabel = (domain: string) => domain;
  domainsLoading = true;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();
  private readonly destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AttachDomainDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AttachDomainDialogData,
    private resellerService: ResellerService,
    private translate: TranslateService,
    private toastrService: ToastrService,
  ) {
    this.form = this.fb.group({
      domain: ["", [(c: AbstractControl) => Validators.required(c)]],
    });
  }

  ngOnInit(): void {
    this.resellerService
      .getAvailableClients(this.data.resellerDomain)
      .pipe(
        catchError(() => of<string[]>([])),
        takeUntil(this.destroy$),
      )
      .subscribe((domains) => {
        this.availableDomains = domains ?? [];
        this.domainsLoading = false;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmit(): void {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid || this.loading) {
      return;
    }

    this.loading = true;

    const domain = this.form.get("domain")?.value as string;

    this.resellerService
      .attachDomain(this.data.resellerDomain, domain)
      .subscribe({
        next: () => {
          this.toastrService.success(
            this.translate.instant("reseller.attachSuccess") as string,
          );
          this.dialogRef.close(domain);
        },
        error: () => {
          this.loading = false;
          this.toastrService.error(
            this.translate.instant("reseller.attachError") as string,
          );
        },
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
